export default "__VITE_ASSET__C8X20my$__"